import Slider from "react-slick";

import CustomArrow from './CustomArrow';

import i18nService from '../../../services/i18nService';

export default function StrapSelector(props) {
  let strapSlides = []
  props.straps.forEach(strap => {
    if (strap.compatible_models.includes(props.selectedModel.id)) {
      strapSlides.push(
        <div key={strap.id}
          className="Carousel-slide"
          onClick={() => props.selectStrap(strap)}
          >
          <div
            className="Carousel-slide-image"
            style={{ backgroundImage: `url(${strap.production_cover})`}}
            />
          <h2 className="Carousel-slide-title">
            <span className="Carousel-slide-title-pre">{strap.name_pre}</span> {strap.name} <span className="Carousel-slide-title-post">{strap.name_post}</span>
          </h2>
          <div className="Carousel-slide-price-container">
            <p className="Carousel-slide-price strike-through"><small>{i18nService.translate(props.locale, 'worth')}</small> {strap.price_from}</p>
            <p className="Carousel-slide-price-notice"><small>{i18nService.translate(props.locale, 'included')}</small></p>
          </div>
        </div>
      )
    }
  })

  const slickSettings = {
    dots: true,
    speed: 500,
    nextArrow: <CustomArrow direction='right' />,
    prevArrow: <CustomArrow direction='left' />
  };

  return (
    <div className="StrapSelector">
      <div className="desktop-only">
        <Slider {...slickSettings} infinite={false} slidesToShow={4} slidesToScroll={2}>{strapSlides}</Slider>
      </div>

      <div className="mobile-only">
        <Slider {...slickSettings} infinite={true} slidesToShow={1} slidesToScroll={1}>{strapSlides}</Slider>
      </div>
    </div>
  )
}
